export const payrollOverviewsListingRoutes = [
  {
    path: 'listing',
    name: 'payroll-overviews-listing',
    component: () =>
      import(/* webpackChunkName: "payroll-overviews-listing" */ './PayrollOverviewsListing.vue')
  }
];
